import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import Molecule from "../../components/Molecule";

const Login: React.FC = () => {
  const history = useHistory();

  const lastUrl = useMemo(() => {
    const url = history.location.search;

    return url;
  }, [history.location.search]);

  const providers = useMemo(
    (): Provider[] => [
      {
        name: "Discord",
        icon: "./discordIcon.svg",
        bgColor: "#5865f2",
        textColor: "#fff",
        url: `/auth/discord${lastUrl}`
      },
      {
        name: "Google",
        icon: "./googleIcon.svg",
        bgColor: "rgb(238, 238, 238)",
        textColor: "#6b7280",
        url: `/auth/google${lastUrl}`
      },
      {
        name: "Apple",
        icon: "./appleIcon.svg",
        bgColor: "#000",
        textColor: "#fff",
        url: `/auth/apple${lastUrl}`
      }
    ],
    [lastUrl]
  );

  return (
    <div className="flex w-full h-screen justify-center items-center px-4 sm:px-0">
      <Molecule className="fixed right-0 top-0" />

      <div className="z-10 flex flex-col w-full sm:max-w-md items-center bg-gray-800 pb-0 sm:pb-3 pt-10 px-4 sm:px-6 rounded-lg shadow-2xl">
        <img
          className="w-14 h-14 mb-4"
          src="./android-chrome-512x512.png"
          alt="logo"
        />
        <span className="text-xs text-white sm:text-sm text-center">
          CHOOSE HOW TO SIGN IN TO YOUR ACCOUNT
        </span>

        <div className="flex flex-col w-full mt-8">
          {providers.map((item) => (
            <button
              onClick={() => history.push(item.url)}
              key={item.name}
              style={{ backgroundColor: item.bgColor, color: item.textColor }}
              className="mb-4 inline-flex items-center uppercase px-3 py-3 border font-semibold border-transparent shadow-sm text-xs sm:text-sm rounded text-white focus:outline-none hover:opacity-80"
            >
              <img className="w-6 h-6 mr-2" src={item.icon} alt={item.name} />
              {item.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Login;

//
// Utils
//

interface Provider {
  name: string;
  icon: string;
  bgColor: string;
  textColor: string;
  url: string;
}
